<template>
  <input
    ref="input"
    class="field-input__inner"
    :placeholder="placeholder"
    :value="value"
    inputmode="numeric"
    @keypress="inputOnlyNumber"
    @input="onInput"
    @focus="() => scrollToEl($refs.input)"
  >
</template>
<script>
import scrollToEl from '../../mixins/scrollToEl';

export default {
  name: 'InputSize',
  mixins: [scrollToEl],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: null,
    },
  },
  methods: {
    inputOnlyNumber(e) {
      const keyCode = (e.keyCode ? e.keyCode : e.which);
      if ((keyCode < 48 || keyCode > 57) || keyCode === 46 || keyCode === 44) { // 46 - точка, 44 - запятая
        e.preventDefault();
      }
    },
    onInput($event) {
      const value = $event.target.value ? parseInt($event.target.value, 10) : '';
      this.$emit('input', value);
    },
  },
};
</script>
